import { OidcSecurityService } from "angular-auth-oidc-client";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class AuthDolomitiInterceptor implements HttpInterceptor {
  private secureRoutes = ['/api', `${window.location.origin}/api`, `${environment.adminUrl}/api`, `${environment.authUrl}/api`];

  constructor(private oidcSecurityService: OidcSecurityService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Ensure we send the token only to routes which are secured
    if (!this.secureRoutes.find((x) => req.url.startsWith(x))) {

      return next.handle(req);
    }

    const token = this.oidcSecurityService.getToken();

    if (!token) {
      return next.handle(req);
    }

    req = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token),
    });

    return next.handle(req);
  }
}